import type React from 'react';
import { memo } from 'react';
import { cache } from 'tm3-core/cache';

interface IProps {
  value?: string | number;
  fallback?: string;
  zeroDefaultFallback?: boolean;
  className?: string;
}

export function formatCurrencyText(
  value: string | number,
  options?: {
    fallback?: string;
    zeroDefaultFallback?: boolean;
  }
): string {
  const currencySymbol = cache?.config?.CURRENCYSYMBOL ?? '£';
  const fallback = options?.fallback ?? '';
  const zeroDefaultFallback = options?.zeroDefaultFallback ?? true;

  if (!value) return zeroDefaultFallback ? `${currencySymbol}0.00` : fallback;

  const parsed = typeof value === 'number' ? value : parseFloat(value);
  if (!parsed || isNaN(parsed)) return fallback;

  return `${parsed > 0 ? '' : '-'}${currencySymbol}${(parsed >= 0 ? parsed : parsed * -1).toFixed(2)}`;
}

const CurrencyLabel: React.FC<IProps> = memo(
  ({ value, fallback = '', zeroDefaultFallback = true, className = '' }) => {
    const currency = formatCurrencyText(value, { fallback, zeroDefaultFallback });
    return <span className={className}>{currency}</span>;
  }
);

export default CurrencyLabel;

export { CurrencyLabel };
